import type { CompanyTrackingViewDto, CompanyTrackingUpdateDto } from '@/types/tracking'
import { apiClient, type ApiResponse } from './client'

// Company tracking API functions
export const trackingApi = {
  // Get the company tracking config (TrackingId, Enabled, ScriptUrl)
  getCompanyTracking: (clientCompanyId: string): Promise<ApiResponse<CompanyTrackingViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Tracking`),

  // Toggle the Enabled flag — server returns the updated DTO
  patchCompanyTracking: (
    clientCompanyId: string,
    dto: CompanyTrackingUpdateDto,
  ): Promise<ApiResponse<CompanyTrackingViewDto>> =>
    apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/Tracking`, dto),
}
